export class Contact {
    constructor(
      public whatsapp?: string,
      public telephoneNumber?: string,
      public mobileNumber?: string,
      public email?: string,
      public website?: string,
      public airbnb?: string,
      public booking?: string,
      public facebook?: string,
      public instagram?: string,
      public youtube?: string,
      public tiktok?: string,
      public otherWebsites?:Record<string, string>
    ){}
}